<script>
  export let titre;
  export let text;
</script>

<div class="wrap-collabsible">
  <input id="collapsible" class="toggle" type="checkbox" />
  <label for="collapsible" class="lbl-toggle">
    {titre}

    <span class="cl-header-icon arrow">
      <svg viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"></path>
      </svg>
    </span>
  </label>
  <div class="collapsible-content">
    <div class="content-inner">
      <!-- <p>
        {@html text}
      </p> -->
      <div class="titre-sub-faq">
        Vous êtes un client / prospect distributeur ?
      </div>
      <p>
        1. Pour obtenir un devis d’une trappe sur mesure, utilisez le
        configurateur qui vous permettra de personnaliser votre trappe, en vous
        permettant de choisir les différentes options.
        <br />
        2. Votre demande sera transmise à notre service commercial qui vous renverra
        une offre de prix ainsi que le délai de livraison.
        <br />
        3. Vous validez le devis auprès de notre service commercial (votre contact
        habituel)
        <br />
        4. La trappe est mise en fabrication et vous est livrée.
      </p>

      <div class="titre-sub-faq mt-3">
        Vous êtes un particulier / artisan/ applicateur ?
      </div>
      <p style="padding-bottom:50px;">
        1. Pour obtenir un devis d’une trappe sur mesure, utilisez le
        configurateur qui vous permettra de personnaliser votre trappe, en vous
        permettant de choisir les différentes options.
        <br />
        2. Votre demande sera transmise à notre service commercial qui se rapprochera
        de l’un de nos distributeurs partenaires afin de vous remettre l’offre de
        prix et le délai de livraison.
        <br />
        3. Vous validez le devis auprès du distributeur. Ce dernier nous valide alors
        la commande.
        <br />
        4. La trappe est mise en fabrication puis envoyée chez notre partenaire distributeur.
        <br />
        5. Vous êtes avertis que la trappe est disponible, vous pouvez aller la retirer
        et procéder au paiement.
      </p>
    </div>
  </div>
</div>

<style>
  .cl-header-icon svg {
    display: inline-block;
    width: 35px;
    height: auto;
  }
  .lbl-toggle .arrow svg {
    transition: transform 0.25s ease-out;
  }

  .toggle:checked + .lbl-toggle .arrow svg {
    transform: rotate(180deg);
  }

  input[type='checkbox'] {
    display: none;
  }
  .wrap-collabsible {
    margin: 1.2rem 0;
  }
  .lbl-toggle {
    display: inline-block;
    font-family: 'introblack';
    font-size: 24px;
    width: 100%;
    text-align: center;
    padding: 1rem;
    color: #fff;
    background: #909090;
    cursor: pointer;
    transition: all 0.25s ease-out;
  }
  .lbl-toggle:hover {
    color: #fff;
  }

  /* .lbl-toggle::before {
    content: ' ';
    display: inline-block;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid currentColor;
    vertical-align: middle;
    margin-right: 0.7rem;
    transform: translateY(-2px);
    transition: transform 0.2s ease-out;
  }
  .toggle:checked + .lbl-toggle::before {
    transform: rotate(90deg) translateX(-3px);
  } */
  .collapsible-content {
    max-height: 0px;
    overflow: hidden;
    transition: max-height 0.25s ease-in-out;
  }
  .toggle:checked + .lbl-toggle + .collapsible-content {
    max-height: 950px;
  }
  .toggle:checked + .lbl-toggle {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .collapsible-content .content-inner {
    color: #fff;
    text-align: left;
    padding: 20px 0 0;
  }
  .collapsible-content p {
    margin-bottom: 0;
  }
  .titre-sub-faq {
    font-family: 'introblack';
    font-size: 27px;
    line-height: 40px;
    padding: 10px 0;
  }
  @media only screen and (max-width: 768px) {
    .collapsible-content .content-inner {
      padding: 20px;
    }
  }
</style>
